import { render } from "./Scroller.vue?vue&type=template&id=53c4b224"
import script from "./Scroller.vue?vue&type=script&lang=js"
export * from "./Scroller.vue?vue&type=script&lang=js"

import "./Scroller.vue?vue&type=style&index=0&id=53c4b224&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__